// extracted by mini-css-extract-plugin
module.exports = {"img":"ad_img__1_Xvo"};